module.exports = __webpack_public_path__ + "static/media/mich_and1.65cf80a1.jpg";